module.exports = __webpack_public_path__ + "static/network4-c7fc10c224a2356e937fe15963d8f087.jpg";